export function getSlug(url: URL): string | null {
  const { pathname } = url;
  const slug = pathname.split('/').filter(Boolean);
  return slug[slug.length - 1];
}
